/* Accessible playback and optional, viewport-aware muted previews. */
(function () {
  function init(scope) {
    scope.querySelectorAll('[data-video-reviews]').forEach(section => {
      if (section.dataset.videoReady) return;
      section.dataset.videoReady = 'true';
      const modal = document.getElementById(section.dataset.videoReviews);
      if (!modal) return;
      const media = modal.querySelector('.video-modal__media');
      const closeButton = modal.querySelector('.video-modal__close');
      const cards = Array.from(section.querySelectorAll('.video-reel__item--playable'));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches || !!navigator.connection?.saveData;
      let trigger, bodyStyle, scrollY = 0, open = false;
      let inertSiblings = [];
      document.body.appendChild(modal);

      function player(raw, title, preview) {
        let url;
        try { url = new URL(raw, location.origin); } catch (_) { return null; }
        if (!['https:', 'http:'].includes(url.protocol)) return null;
        const host = url.hostname.replace(/^www\./, '');
        let src = '';
        if (['youtube.com', 'm.youtube.com', 'youtu.be', 'youtube-nocookie.com'].includes(host)) {
          const id = host === 'youtu.be' ? url.pathname.split('/')[1] : url.searchParams.get('v') || url.pathname.match(/\/(?:embed|shorts)\/([\w-]+)/)?.[1];
          if (!id || !/^[\w-]{11}$/.test(id)) return null;
          src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0' + (preview ? '&mute=1&controls=0&loop=1&playlist=' + id : '');
        } else if (['vimeo.com','player.vimeo.com'].includes(host)) {
          const id = url.pathname.match(/(?:^|\/)(\d+)(?:\/|$)/)?.[1];
          if (!id) return null;
          src = 'https://player.vimeo.com/video/' + id + '?autoplay=1' + (preview ? '&muted=1&loop=1&background=1' : '');
        }
        const element = document.createElement(src ? 'iframe' : 'video');
        element.src = src || url.href;
        element.title = title || 'Customer video';
        if (src) { element.allow = 'autoplay; fullscreen; encrypted-media'; element.allowFullscreen = true; }
        else { element.autoplay = true; element.controls = !preview; element.playsInline = true; element.muted = !!preview; element.loop = !!preview; }
        if (preview) { element.tabIndex = -1; element.setAttribute('aria-hidden','true'); element.className = 'video-reel__iframe'; }
        return element;
      }
      const visible = new Set();
      const posters = new Map(cards.map(card => [card, card.querySelector('.video-reel__media').innerHTML]));
      function syncPreviews() {
        cards.forEach(card => {
          const container = card.querySelector('.video-reel__media');
          const play = !paused && !open && !document.hidden && visible.has(card);
          if (play && !container.querySelector('iframe, video')) {
            const preview = player(card.dataset.videoUrl, card.getAttribute('aria-label'), true);
            if (preview) container.replaceChildren(preview);
          } else if (!play && container.querySelector('iframe, video')) container.innerHTML = posters.get(card);
        });
      }
      const motionButton = document.createElement('button');
      motionButton.type = 'button'; motionButton.className = 'video-reviews__motion';
      function syncMotion() {
        motionButton.textContent = paused ? 'Play previews' : 'Pause previews';
        motionButton.setAttribute('aria-pressed', String(paused));
        syncPreviews();
      }
      motionButton.addEventListener('click', () => { paused = !paused; syncMotion(); });
      if (cards.length) section.querySelector('.video-reviews__header')?.appendChild(motionButton);
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
        syncPreviews();
      }, {threshold:0.15});
      cards.forEach(card => observer.observe(card));
      const motionChange = () => { paused = reduced.matches; syncMotion(); };
      reduced.addEventListener('change', motionChange);
      document.addEventListener('visibilitychange', syncPreviews);
      syncMotion();

      function close() {
        if (!open) return;
        open = false;
        modal.setAttribute('aria-hidden','true'); modal.inert = true;
        media.replaceChildren();
        inertSiblings.forEach(([element, wasInert]) => { element.inert = wasInert; });
        inertSiblings = [];
        Object.assign(document.body.style, bodyStyle);
        document.body.classList.remove('video-open');
        window.scrollTo(0, scrollY);
        trigger?.focus({preventScroll:true});
        syncPreviews();
      }
      function show(card) {
        if (open) return;
        trigger = card;
        const video = player(card.dataset.videoUrl, card.querySelector('.video-reel__name')?.textContent, false);
        if (!video) {
          const error = document.createElement('p'); error.role = 'alert'; error.className = 'video-modal__error';
          error.textContent = 'This video link is unavailable.'; media.replaceChildren(error);
        } else media.replaceChildren(video);
        open = true; scrollY = window.scrollY;
        bodyStyle = Object.fromEntries(['position','top','width','overflow'].map(key => [key, document.body.style[key]]));
        inertSiblings = Array.from(document.body.children).filter(el => el !== modal && !['SCRIPT','STYLE','LINK'].includes(el.tagName)).map(el => [el, el.inert]);
        inertSiblings.forEach(([el]) => { el.inert = true; });
        Object.assign(document.body.style, {position:'fixed',top:-scrollY+'px',width:'100%',overflow:'hidden'});
        document.body.classList.add('video-open');
        modal.inert = false; modal.setAttribute('aria-hidden','false');
        syncPreviews();
        requestAnimationFrame(() => { if (open) closeButton.focus(); });
      }
      cards.forEach(card => {
        card.addEventListener('click', () => show(card));
        card.addEventListener('keydown', event => { if (['Enter',' '].includes(event.key)) { event.preventDefault(); show(card); } });
      });
      closeButton.addEventListener('click', close);
      modal.querySelector('.video-modal__backdrop').addEventListener('click', close);
      const keydown = event => {
        if (!open) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          const focusable = Array.from(modal.querySelectorAll('button, iframe, video[controls], a[href]')).filter(el => el.getClientRects().length);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      };
      document.addEventListener('keydown', keydown);
      const unload = event => {
        if (!event.target.contains(section)) return;
        close(); observer.disconnect(); modal.remove();
        reduced.removeEventListener('change', motionChange);
        document.removeEventListener('visibilitychange', syncPreviews);
        document.removeEventListener('keydown', keydown);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
